import { NationalCommitteesCatalogRedirect } from "./_NationalCommitteesRedirect";

export default function CommitteesIndexPage() {
  return <NationalCommitteesCatalogRedirect status="active" />;
}
